/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

function ccQuickBuyClickHandle(btn){

  $btn = jQuery(btn)
  variant_id = $btn.prev('[name="id"]').val();
  collection_title = $btn.closest('[data-ccinfo="collection-template"]').attr('data-cc_collection');

  let pushDataRaw = {};
  pushDataRaw.variant_id = variant_id;
  pushDataRaw.collection_title = collection_title ? collection_title : '';
  
  // jQuery.ajax({
  //   type: 'GET', 
  //   url: '/cart.js',
  //   dataType: 'json', 
  //   success: function(res){
  //     console.log(res);
  //     pushDataRaw.cart_data = res;
      // jQuery.ajax({
      //   type: 'POST', 
      //   url: '/cart/add.js',
      //   dataType: 'json', 
      //   data: {
      //     id: variant_id,
      //     quantity: 1
      //   },
      //   success: function(res){
      // pushDataRaw.cart_added = res;
      // ccPushEventAddToCart(pushDataRaw)
      //   }
      // });
    // }
  // });

}

function ccPushEventAddToCart(pd){  
  
  dataLayer.push({
    'ecommerce': null
  });
  
  let dataLayerObject = {
    'event': 'add_to_cart',
    'ecommerce': {
      'items': [{
        'item_id': pd.variant_id,    
        'item_name': pd.cart_added.product_title.replace('"','').replace("'",''),
        'item_brand': pd.cart_added.vendor.replace('"','').replace("'",''),
        'item_category': pd.collection_title.replace('"','').replace("'",''),
        'item_variant': pd.cart_added.sku,    
        'currency': pd.cart_data.currency,    
        'price': parseInt(pd.cart_added.final_line_price) / 100 
      }]   	
    }   
  }
  //console.log(dataLayerObject)
  dataLayer.push(dataLayerObject);
}